import { render, staticRenderFns } from "./MedicalContentImageTextBox.vue?vue&type=template&id=a647a95a&scoped=true&"
import script from "./MedicalContentImageTextBox.vue?vue&type=script&lang=js&"
export * from "./MedicalContentImageTextBox.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentImageTextBox.vue?vue&type=style&index=0&id=a647a95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647a95a",
  null
  
)

export default component.exports